<template>
  <button class="btn btn-sm btn-secondary" @click="show"><font-awesome-icon icon="dollar-sign"/> {{$t('chargeRegisterFee')}}
    <b-modal v-model="showForm" :title="$t('chargeRegisterFee')" @ok="charge">
      <form-input :model="formModel" attribute="fee" :errors="formErrors" :placeholder="$t('registerFee')" :label="$t('amount')"></form-input>
    </b-modal>
  </button>
</template>

<script>
export default {
  props: ['brandName'],
  data: function () {
    return {
      showForm: false,
      formModel: {
        phone: null
      },
      formErrors: []
    }
  },
  methods: {
    show() {
      this.formModel = {
        fee: 500000
      };
      this.showForm = true;
    },
    charge(evt) {
      evt.preventDefault();
      if (!this.formModel.fee || this.formModel.fee < 0) {
        this.formErrors.push({param: "fee", msg: this.$t('feeMustNotBeEmpty'), location: "body"})
        return false;
      } else {
        this.$swal({
          text: this.$t('chargeRegisterFeeConfirm', [this.brandName.name, this.formModel.fee]),
          icon: "info",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            let loader = this.$loading.show();
            this.$service({url: 'sms-brand-name/charge-register-fee/'+ this.brandName._id, method: 'post', data: this.formModel}).then(response => {
              if (response.data) {
                this.showForm = false;
                this.$swal({
                  title: this.$t('success'),
                  icon: 'success',
                  toast: true,
                  position: 'top-end',
                  timer: 5000,
                });
              } else {
                this.$swal({
                  title: this.$t('error'),
                  icon: 'error'
                });
              }
            }).catch(error => {
              if (error.response.data.message) {
                this.$swal({
                  text: error.response.data.message,
                  icon: 'error'
                });
              } else {
                this.$swal({
                  text: error.response.data[0].msg,
                  icon: 'error'
                });
              }
            }).finally(() => {
              loader.hide();
            });
          }
        });
      }
    }
  },
  i18n: {
    messages: {
      en: {
        chargeRegisterFee: "Charge register fee",
        registerFee: "Register fee",
        feeMustNotBeEmpty: "Fee must not be empty",
        chargeRegisterFeeConfirm: "Are you sure to charge brand name \"%s\" the amount of %s for registration fee?",
        amount: "Amount"
      },
      vi: {
        chargeRegisterFee: "Phí ĐK tên định danh",
        registerFee: "Phí đăng ký tên định dang",
        feeMustNotBeEmpty: "Không được bỏ trống",
        chargeRegisterFeeConfirm: "Bạn có chắc muốn thu brand name \"{0}\" số tiền {1} cho việc đăng ký tên định danh?",
        amount: "Số tiền"
      }
    }
  }
}
</script>